import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";
import {
  toggleSelectionWindow, toggleSelectionFeatureInfo, setCameFromPage,
} from "../../actions/actionFunctions";

import Analytics from "../../analytics";
import {ROUTES} from "../../routes";


const ShoppingCartButton = (props) => {

  const {className, cartItems, setCameFromPage, selectionFeatureInfo, toggleSelectionFeatureInfo, toggleSelectionWindow,
    selectionOpened, selectionGroup, history, location} = props;

  const shCartButtonClick = () => {
    Analytics.sendClickEvent('go-to-shopping-cart');

    if (selectionOpened) {
      toggleSelectionWindow(false, selectionGroup);
      setCameFromPage("materials");
      if (selectionFeatureInfo) {
        toggleSelectionFeatureInfo(null);
      }
    } else if (location && (location.pathname === ROUTES.home || location.pathname === ROUTES.quoteDesign)) {
      setCameFromPage(ROUTES.quoteDesign);
    }

    if (!window.location.href.includes('shoppingcart')) {
      history.push(ROUTES.shoppingcart);
    }

  };

  return (
    <button className={"materials-button materials-button--cart " + (className || '')} onClick={shCartButtonClick}>
      <span className="materials-button__text"><FormattedMessage id="header.cartButton"/></span>
      {cartItems.length ? <span className="materials-button--cart-length bold">{cartItems.length}</span> : null}
    </button>
  )

}

ShoppingCartButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {selectionFeatureInfo, selectionOpened, selectionGroup} = store.selectionState;

  return {
    cartItems,
    selectionFeatureInfo,
    selectionOpened,
    selectionGroup,
  };
};

const mapDispatchToProps = {
  setCameFromPage,
  toggleSelectionFeatureInfo,
  toggleSelectionWindow,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartButton)
);
